// extracted by mini-css-extract-plugin
export default {"SupportBlock":"SupportBlock_SupportBlock__kJNMN","SupportBlock__noMargin":"SupportBlock_SupportBlock__noMargin__42wR0"};